import { render, staticRenderFns } from "./PropertyNumberWithUnitField.vue?vue&type=template&id=28577bba&"
import script from "./PropertyNumberWithUnitField.vue?vue&type=script&lang=js&"
export * from "./PropertyNumberWithUnitField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports